export default __webpack_public_path__ + "static/media/interviewsIcon.578cd4bd.svg";